import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    success: false,
};

const passwordSlice = createSlice({
    name: 'password',
    initialState,
    reducers: {
        passwordRequest: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        passwordSuccess: (state) => {
            state.loading = false;
            state.success = true;
        },
        passwordFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },

});

export const { passwordRequest, passwordSuccess, passwordFailure } = passwordSlice.actions;


export const changePasswordReducer = passwordSlice.reducer;

